export default {
    ssl_steps: {
        csr_and_domain: {
            label: 'CSR & Domain',
            title: 'Enter CSR & domains {packageName} will cover',
            subtitle:
                'Step {step}. Enter CSR generated based on your company info and domains you own.',
        },
        select_dcv_method: {
            label: 'Select DCV Method',
            title: 'Confirm that you own the domain',
            subtitle: 'Step {step}. Select domain control validation method.',
        },
        admin_email: {
            label: 'Admin Email',
            title: '{packageName} contacts',
            subtitle: 'Step {step}. Specify who we should send SSL file to',
        },
        review_and_submit: {
            label: 'Review & Submit',
            title: 'Review & submit',
            subtitle: 'Step {step}. Check SSL information below',
        },
    },
    title: 'SSL Certificates',
    ssl_certificates: 'SSL Certificates',
    certificate_id: 'ID',
    package_name: 'NAME',
    num_years: 'PURCHASED FOR',
    expired_date: 'EXP DATE',
    auto_renew: 'AUTO RENEW',
    status: 'STATUS',
    info: {
        activate_it: 'activate it',
        install_it: 'install it',
        validation_process: 'validation process',
        installation_guides: 'installation guides',
        issued_a_year: 'issued for 1 year',
        new_hint:
            'To use an SSL you first need to {activateIt} and then {installIt}',
        pending_hint: 'Complete {validationProcess}',
        active_hint:
            'Your SSL has been issued and is ready for installation.{lineBreak}Check our {installationGuides} for the most commonly-used server types.',
        active_more_hint:
            'Your SSL has been {issuedAYear} and is ready for installation.{lineBreak}Check our {installationGuides} for the most commonly-used server types.',
        renewal_hint:
            'To renew an SSL you first need to {activateIt} and then {installIt}',
        pauses_on: 'Pauses on {pausesDate}',
    },
    active_step_csr: {
        hint: 'Using existing CSR for renewing SSL may create a security threat, so we recommend you get a new CSR every time.{lineBreak}You can see What is CSR and how to create one by clicking on the "Read More" button.',
        enter_csr: 'Enter CSR',
        enter_csr_placeholder: 'Enter CSR here',
        primary_domain: 'Primary domain',
        primary_domain_placeholder: 'We will add it from CSR',
        additional_domains: 'Add more domains',
        additional_domains_placeholder: 'example.com',
    },
    active_ssl_title: 'Active SSL',
    ssl_certificate_detail: 'SSL Certificate Detail',
    active_step_dcv: {
        title: 'Edit DCV Method for {packageName}',
        hint: 'You can see How to complete DCV by clicking on the "Read More" button.',
        dcv_method: 'DCV method',
        approver_email: 'Approver email',
        hints: {
            dns: 'You’ll need to create a CNAME record via host records page, cPanel or DNS provider.',
            http: 'You’ll need to download a file and then upload it to your domain’s root folder.',
            email: "The Certificate Authority will send a validation email (wherever applicable), and you'll need to click the included link to complete DCV.",
        },
        same_dcv: 'Same DCV for all domains',
    },
    active_step_admin_email: {
        company: {
            title: 'Company',
            form: {
                company_name: {
                    label: 'Company name',
                    placeholder: 'Legal name',
                },
                company_business: {
                    label: 'Doing business as',
                    placeholder:
                        'If you operate under different name (optional)',
                },
                company_registration_number: {
                    label: 'Registration number',
                    placeholder:
                        'Helps getting {validationType} faster (optional)',
                },
            },
        },
        legal_address: {
            title: 'Legal Address',
            form: {
                country_state: {
                    label: 'Country & State',
                    state_placeholder: 'State / Province',
                },
                city_zip: {
                    label: 'City & zip/postal code',
                    city_placeholder: 'City',
                    zip_placeholder: 'Enter Zip/Postal',
                },
                address: {
                    label: 'Address',
                    placeholder: 'Enter Address',
                },
            },
        },
        representative: {
            title: 'Representative',
            form: {
                full_name: {
                    label: 'Full name',
                    first_name_placeholder: 'First Name',
                    last_name_placeholder: 'Last Name',
                },
                job_title: {
                    label: 'Job title',
                    placeholder: 'Must be any kind of manager (CEO, VP, etc)',
                },
                phone_number: {
                    label: 'Phone Number',
                },
                their_email: {
                    label: 'Their email',
                },
            },
        },
        ssl_will_be_sent_to: {
            title: 'SSL will be sent to',
            form: {
                admin_email: {
                    label: 'Admin Email',
                },
            },
        },
    },
    ssl_validation_types: {
        dv: 'Domain (DV)',
        dv_full: 'Domain Validation (DV)',
        ov: 'Organization (OV)',
        ov_full: 'Organization Validation (OV)',
        ev: 'Extended (EV)',
        ev_full: 'Extended Validation (EV)',
    },
    active_step_review: {
        hint: 'You will get instructions on how to complete domain control validation (DCV) on the next step. When you complete DCV, certificate authority will check your request and issue SSL according to submitted information.',
        company: 'Company',
        company_name: 'Company name',
        doing_business_as: 'Doing business as',
        registration_number: 'Registration number',
        legal_address: 'legal address',
        country_state: 'Country & state',
        city_zip_code: 'City & zip code',
        address: 'Address',
        representative: 'representative',
        full_name: 'Full name',
        job_title: 'Job title',
        phone_number: 'Phone number',
        their_email: 'Their email',
        will_sent_to: 'SSL will be sent to',
        admin_email: 'Admin email',
        domain_dcv: 'Domains secured & DCV method',
        domain_dcv_hints: {
            dns: 'Create a CNAME record',
            http: 'Upload the validation file to {domain}{fileFolder}',
            email: 'Get email at {email}',
        },
    },
    lifetime_limit_modal: {
        title: 'SSL Lifetime Limit',
        confirm_title:
            'All SSLs purchased for{lineBreak}longer than 1 year(s) or later',
        confirm_description:
            "SSL will need to be reissued annually to avoid service interruption. We'll send several email reminders starting 30 day(s) before the 1 year(s) SSL’s expiration.",
    },
    reissue_ssl_title: 'Reissue SSL',
    extend: {
        title: 'Extend SSL',
        package: 'SSL Package',
        package_name: 'Package name',
        additional_domains: 'Additional domains',
        domains: 'Domains',
    },
    ssl_detail: {
        guides: {
            dns_validation: {
                title: 'DNS validation: How to get a DNS record',
                content:
                    '1Byte’s Default DNS, Backup DNS or FreeDNS: Visit the host records page.{lineBreak}1Byte Hosting DNS: Create the CNAME record manually in your cPanel account.{lineBreak}Other: Create the CNAME record manually at your DNS provider.',
            },
            dns_record: {
                title: 'Guide: DNS record added properly',
                content:
                    'As you’ve added a CNAME to your domain’s DNS zone, check if the CNAME has been added properly:{lineBreak}Go to {cnameLookupUrl}.{lineBreak}Enter CNAME value and click “CNAME lookup”. If you get “DNS record published” all is correct.',
            },
            http_validation: {
                title: 'HTTP validation: Upload the validation file',
                get_records: 'file from this page (Edit methods)',
                content:
                    'Create “.well-known” and “pki-validation” folders at each secured domain{fileFolder} and upload the validation {getRecords}.{lineBreak}You should be able to access the file from: {accessFileUrl}{lineBreak}{fileName} must be accessible from every URL',
            },
            email_validation: {
                title: 'Email validation: How to resend an approver email',
                change_validation_method:
                    'change validation method (Edit methods)',
                these_emails: 'these emails',
                content:
                    'An email with a validation link will be sent to {approverEmails} shortly. Only a predefined list of email addresses related to your domain name can be used to pass domain control validation. If you don’t have access to {theseEmails}, {changeValidationMethod}.',
            },
        },
        additional_info: {
            admin_details: 'Admin details',
            secures: 'Secures',
            validation_method: 'Validation method',
            approver_email: 'Approver Email',
            company: 'Company',
            legal_address: 'Legal Address',
            representative: 'Representative',
            admin_email: 'Admin Email',
        },
        csr_info: {
            server_type: 'Server Type',
            server_type_hint:
                'Indicates the type of server the issued certificate will be compatible with.',
            server_type_content: 'Apache, Nginx, cPanel, or Other',
            hashing_algorithm: 'Hashing Algorithm',
            hashing_algorithm_hint: 'Protects against certificate forgery.',
            hashing_algorithm_content: 'SHA-2',
            methods_in_use: 'Methods in Use',
            csr_code: 'CSR Code',
        },
        general_info: {
            status: 'Status',
            pending_status_hint:
                '1Byte is now checking the status for this certificate. Please wait a few minutes for an update.',
            expired_date: 'Exp Date',
            activation_date: 'Activation date',
            issued_for: 'Issued for',
            issued_for_hint: "Max SSL validity that doesn't require reissue.",
            pauses: 'Pauses',
            pauses_hint:
                'Please reissue before this date to avoid service interruption.',
            purchased_for: 'Purchased for',
            type: 'Type',
            domains: 'Domains',
            ssl_id: 'SSL ID',
            order_id: 'Order ID',
            ca_order_id: 'CA order ID',
            ca_order_id_hint:
                'About CA order ID, please {clickHere} for more details',
        },
    },
    ssl_alert: {
        ready: {
            title: 'Your SSL has been issued and is ready for installation',
            description:
                'Check our installation guides for the most commonly-used server types. Your website will be secured until {expireDate}. To keep a secure connection after this date, you will need to buy a new renewal SSL and install it. We’ll send a reminder when it’s time. You can see installation guides by clicking on the "Read More" button.',
            installation_guides: 'installation guides',
            ssl_lifetime_limit: 'SSL lifetime limit',
            title_more_sans:
                'Your SSL has been issued for 1 year and is ready for installation',
            description_more_sans:
                'Check our {installationGuides} for the most commonly-used server types. Your website will be secured until {expireDate}. To keep a secure connection after this date, you will need to reissue and reinstall your SSL in order to comply with the industry {SSLLifetimeLimit}. We’ll send a reminder when it’s time.',
        },
        ready_active: {
            title: 'Get started with new SSL',
            description:
                'To use an SSL you first need to activate it and then install it on your server. To activate your SSL, {submitData} to the Certificate Authority and {confirmControl} the domain you wish to secure.',
            submit_data: 'submit your data',
            confirm_control: 'confirm that you control',
        },
    },
    qty: 'Qty',
    buy_more_domains_alert:
        'Purchasing more domains does not change the SSL expiration date. If your additional domains are added 30 days before SSL expiration, they will be secured for 30 days only.',
    revoke: {
        title: 'Revoke',
        warning_title: 'SSL will be cancelled',
        warning_content:
            'Once you revoke SSL you will not be able use it on your website.',
    },
    csr_decode: {
        modal_title: 'CSR Code',
        title: '{name} CSR Code Translation',
        subtitle:
            "Review this decoded version of your CSR to verify that the information it contains is accurate. A CSR (Certificate Signing Request) is a code generated server-side or by third party; it's required for SSL activation. {contactSupport} if you have concerns about your CSR.",
        contact_support: 'Contact Support',
        primary_domain: 'Primary Domain',
        email: 'Email',
        company: 'Company',
        department: 'Department',
        location: 'Location',
    },
    csr_decode_type: {
        domain: 'Domain',
        locality: 'Locality',
        state: 'State',
        organization: 'Organization',
        organization_unit: 'Organization Unit',
        email: 'Email',
        country: 'Country',
        basic_constraints: 'Basic Constrains',
        key_usage: 'Key Usage',
        ext_key_usage: 'Extended Key Usage',
        subject_alt_name: 'DNS Subject Alt Names',
    },
    related_title: 'Related SSL Certificates',
    dcv_download: {
        modal_title: 'Download File',
        title: 'Download File For Domain Control Validation',
        subtitle:
            "To complete the DCV procedure: Download the file, then create the following path for the domain(s)/subdomain(s) your certificate is being activated: {fileFolder} and upload it there. Do not edit the file's name or contents. A DCV (Domain Control Validation) method is a way of proving that you own or control a certain registered domain name. View this {knowledgeBase} article to learn more.",
    },
    knowledge_base: 'Knowledge base',
    domains_to_validate: 'Domains to Validate',
    domains: 'Domains',
    file_to_download: 'File to download',
    primary: 'Primary',
    edit_dcv: {
        title: 'Edit DCV',
        edit_for: 'Edit DCV Method for',
        hint: 'A Domain Control Validation (DCV) method is necessary for security purposes. The Certificate Authority uses the DCV to verify that the person placing the request owns the domain and/or is authorized to use it. You can see What DCV is and How to use it by clicking the by clicking on the "Read More" button.',
    },
    resend_mail: {
        modal_title: 'Resend Email',
        title: 'Resend Email For Domain Control Validation',
        subtitle:
            "Please find it and click the included the link to complete your DCV procedure. If you haven't received the email, simply click the RESEND button and we'll send it again. A DCV (Domain Control Validation) method is a way of proving that you own or control a certain registered domain name. View this {knowledgeBase} article to learn more.",
    },
    via: 'via',
    get_record: {
        title: 'Get Record',
        heading_title: 'Get Record For Domain Control Validation',
        main_content:
            'A DCV (Domain Control Validation) method is a way of proving that you own or control a certain registered domain name. To complete the DCV procedure, use the information provided below to create a CNAME record for your domain(s).',
        content: {
            0: "If you use 1Byte's Basic DNS: Visit the host records page to create the CNAME for each of the domains to be protected.",
            1: 'If you use 1Byte DNS: Create the CNAME record manually in your cPanel account.',
            2: "If you use any other DNS: You'll need to create the CNAME record manually at your DNS provider.",
            3: 'View this {knowledgeBase} article to learn more.',
        },
    },
    host: 'Host',
    target: 'Target',
    change_primary_domain: {
        modal_title: 'Primary Domain Change',
        title: 'The common name in your CSR is different from the one the initial certificate was issued for.',
        subtitle:
            'Having "{newDomain}" in CSR, will create a new SSL Certificate. Initial SSL with "{oldDomain}" will be revoked and you won’t be able to use it again.',
    },
    confirm_reissue: {
        modal_title: 'Reissue {name} certificate',
        content:
            'Please be aware: Once you begin the reissue process, you will no longer be able to download the old certificate. Do you wish to reissue?',
    },
};
